import {ITranslationTagStateIdentifier} from "../../shared/models/ITranslationTagStateIdentifier";

export const getTagChangeId = (identifier: ITranslationTagStateIdentifier) =>
    `${identifier.keyId}_${identifier.tagName}_${identifier.languageCode || ''}`.toLowerCase();
